import { useEffect } from 'react';
import { useRouter } from 'next/router';

import posthog from 'posthog-js';

const usePageview = () => {
  const router = useRouter();

  useEffect(() => {
    const isPosthogInitialized = () => typeof posthog?.capture === 'function';

    const handleRouteChange = (url: string) => {
      if (isPosthogInitialized()) {
        posthog.capture('$pageview', {
          current_url: url,
        });
      }
    };
    router.events.on('routeChangeComplete', handleRouteChange);

    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [router]);
};

export default usePageview;
